import * as ActionTypes from './actionTypes.js';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchRequestsList = (params = {}) =>
  apiActionCreator({
    'endpoint': `/devices/requests${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_REQUESTS_DEVICE_LIST,
      ActionTypes.FETCHED_REQUESTS_DEVICE_LIST,
      [
        ActionTypes.FETCHED_REQUESTS_DEVICE_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchRequestsDetail = (requestType, dealerId, requestId) =>
  apiActionCreator({
    'endpoint': `/devices/requests/${requestType}/${dealerId}/${requestId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_REQUEST_DEVICE_DETAIL,
      ActionTypes.FETCHED_REQUEST_DEVICE_DETAIL,
      [
        ActionTypes.FETCHED_REQUEST_DEVICE_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
  
export const fetchDesisntallationMotives = () =>
  apiActionCreator({
    'endpoint': '/devices/requests/desisntallation-motives',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DESISNTALLATION_MOTIVES_LIST,
      ActionTypes.FETCHED_DESISNTALLATION_MOTIVES_LIST,
      [
        ActionTypes.FETCHED_DESISNTALLATION_MOTIVES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const addRequestsDevice =
  (data = {}) =>
    (dispatch) =>
      dispatch(
        apiActionCreator({
          'endpoint': '/devices/requests',
          'authenticated': true,
          'types': [
            ActionTypes.ADDING_REQUESTS_DEVICE,
            [
              ActionTypes.ADDED_REQUESTS_DEVICE,
              MessageActions.addMessageBoxInfo('Solicitud de realizada correctamente'),
            ],
            [
              ActionTypes.ADDED_REQUESTS_DEVICE_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          'data': {...data},
        })
      );

export const fetchRequestId = (requestType) =>
  apiActionCreator({
    'endpoint': `/devices/requests/sequence/${requestType}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_REQUEST_ID,
      ActionTypes.FETCHED_REQUEST_ID,
      [
        ActionTypes.FETCHED_REQUEST_ID_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchChassisListBySearch = (params = {}) =>
  apiActionCreator({
    'endpoint': `/devices/requests${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_REQUESTS_CHASSIS_DEVICE_LIST,
      ActionTypes.FETCHED_REQUESTS_CHASSIS_DEVICE_LIST,
      [
        ActionTypes.FETCHED_REQUESTS_CHASSIS_DEVICE_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const clearRequestsDeviceList = () => ({
  'type': ActionTypes.CLEAR_REQUESTS_DEVICE_LIST,
});

export const fetchVehiclesInfoBySearch = (params) =>
  apiActionCreator({
    'endpoint': `/devices/requests/vehicles${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_INFO_LIST_BY_SEARCH,
      ActionTypes.FETCHED_VEHICLES_INFO_LIST_BY_SEARCH,
      [
        ActionTypes.FETCHED_VEHICLES_INFO_LIST_BY_SEARCH_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const clearVehiclesInfoList = () => {
  return {
    'type': ActionTypes.CLEAR_VEHICLES_INFO_LIST_BY_SEARCH,
  };
};
